var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DocumentAdd component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDocumentAdd extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.43717 2.95499C4.56201 2.83015 4.73133 2.76001 4.90789 2.76001H11.6757L18.3149 9.39918V10.98C18.3149 11.3942 18.6507 11.73 19.0649 11.73C19.4791 11.73 19.8149 11.3942 19.8149 10.98V9.08852C19.8149 8.88961 19.7359 8.69884 19.5952 8.55819L12.5167 1.47968C12.3761 1.33903 12.1853 1.26001 11.9864 1.26001H4.90789C4.33351 1.26001 3.78266 1.48818 3.37651 1.89433C2.97036 2.30048 2.74219 2.85133 2.74219 3.42571V18.9984C2.74219 19.5728 2.97036 20.1237 3.37651 20.5298C3.78265 20.936 4.33351 21.1641 4.90789 21.1641H9.66922C10.0834 21.1641 10.4192 20.8284 10.4192 20.4141C10.4192 19.9999 10.0834 19.6641 9.66922 19.6641H4.90789C4.73134 19.6641 4.56201 19.594 4.43717 19.4692C4.31232 19.3443 4.24219 19.175 4.24219 18.9984V3.42571C4.24219 3.24916 4.31232 3.07983 4.43717 2.95499ZM16.6279 13.479C17.0421 13.479 17.3779 13.8148 17.3779 14.229V17.3596H20.5083C20.9225 17.3596 21.2583 17.6954 21.2583 18.1096C21.2583 18.5238 20.9225 18.8596 20.5083 18.8596H17.3779V21.99C17.3779 22.4042 17.0421 22.74 16.6279 22.74C16.2137 22.74 15.8779 22.4042 15.8779 21.99V18.8596H12.7473C12.3331 18.8596 11.9973 18.5238 11.9973 18.1096C11.9973 17.6954 12.3331 17.3596 12.7473 17.3596H15.8779V14.229C15.8779 13.8148 16.2137 13.479 16.6279 13.479Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDocumentAdd.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentAdd.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentAdd.prototype, "size", void 0);
if (customElements.get('cat-icon-document-add') === undefined) {
    customElements.define('cat-icon-document-add', BlocksIconDocumentAdd);
}
